import { EuiTab } from '@elastic/eui';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const TabsContainer = styled.div``;

export const Tab = styled(EuiTab)(
  ({ theme: { PRIMARY } }) => css`
    padding: 10px;
    text-decoration: none !important;
    background-color: none !important;
    &.euiTab.euiTab-isSelected {
      color: ${PRIMARY};
      cursor: default;
    }
    &.euiTab.euiTab-isSelected::after {
      background-color: ${PRIMARY};
    }
  `
);
